module.exports = __webpack_public_path__ + "static-portal/img/al-2.6255f89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/al-2.jpg
// module id = KpqH
// module chunks = 4